// System roles and permissions (PRD §2, §15). Tenant-defined custom roles come later;
// until then roles are fixed here and stored per user as text (see ADR-0002).
export const USER_KINDS = ['office', 'floor', 'client'];
export const OPERATOR_ROLES = [
    'operator_admin',
    'site_manager',
    'supervisor',
    'associate',
    'billing',
];
export const CLIENT_ROLES = ['client_admin', 'client_user'];
export const ROLES = [...OPERATOR_ROLES, ...CLIENT_ROLES];
export const PERMISSIONS = [
    'site:read',
    'site:manage',
    'client:read',
    'client:manage',
    'user:read',
    'user:manage',
    'device:read',
    'device:manage',
    'audit:read',
    'item:read',
    'item:manage',
    'location:read',
    'location:manage',
    'partner:read',
    'partner:manage',
    'config:read',
    'config:manage',
    'inventory:read',
    'inventory:move',
    'inventory:adjust',
    'inventory:approve',
    'inventory:hold',
    'inventory:count',
    'inbound:read',
    'inbound:submit',
    'inbound:receive',
    'inbound:approve',
    'putaway:execute',
    'outbound:read',
    'outbound:submit',
    'outbound:manage',
    'outbound:pick',
    'outbound:pack',
    'outbound:ship',
];
export const ROLE_PERMISSIONS = {
    operator_admin: PERMISSIONS,
    site_manager: [
        'site:read',
        'client:read',
        'user:read',
        'user:manage',
        'device:read',
        'device:manage',
        'audit:read',
        'item:read',
        'location:read',
        'location:manage',
        'partner:read',
        'config:read',
        'inventory:read',
        'inventory:move',
        'inventory:adjust',
        'inventory:approve',
        'inventory:hold',
        'inventory:count',
        'inbound:read',
        'inbound:submit',
        'inbound:receive',
        'inbound:approve',
        'putaway:execute',
        'outbound:read',
        'outbound:submit',
        'outbound:manage',
        'outbound:pick',
        'outbound:pack',
        'outbound:ship',
    ],
    supervisor: [
        'site:read',
        'client:read',
        'user:read',
        'device:read',
        'item:read',
        'location:read',
        'partner:read',
        'config:read',
        'inventory:read',
        'inventory:move',
        'inventory:adjust',
        'inventory:hold',
        'inventory:count',
        'inbound:read',
        'inbound:submit',
        'inbound:receive',
        'inbound:approve',
        'putaway:execute',
        'outbound:read',
        'outbound:submit',
        'outbound:manage',
        'outbound:pick',
        'outbound:pack',
        'outbound:ship',
    ],
    associate: [
        'site:read',
        'item:read',
        'location:read',
        'config:read',
        'inventory:read',
        'inventory:move',
        'inventory:count',
        'inbound:read',
        'inbound:receive',
        'putaway:execute',
        'outbound:read',
        'outbound:pick',
        'outbound:pack',
        'outbound:ship',
    ],
    billing: [
        'site:read',
        'client:read',
        'item:read',
        'partner:read',
        'inventory:read',
        'inbound:read',
        'outbound:read',
    ],
    client_admin: [
        'site:read',
        'client:read',
        'user:read',
        'user:manage',
        'item:read',
        'partner:read',
        'inventory:read',
        'inbound:read',
        'inbound:submit',
        'outbound:read',
        'outbound:submit',
    ],
    client_user: [
        'site:read',
        'client:read',
        'item:read',
        'inventory:read',
        'inbound:read',
        'outbound:read',
    ],
};
/** Which roles a user of each kind may hold. */
export const ROLES_BY_KIND = {
    office: ['operator_admin', 'site_manager', 'supervisor', 'billing'],
    floor: ['supervisor', 'associate'],
    client: CLIENT_ROLES,
};
/** Which roles a holder of each role may grant (prevents privilege escalation). */
const ASSIGNABLE_BY = {
    operator_admin: ROLES,
    site_manager: ['supervisor', 'associate'],
    supervisor: [],
    associate: [],
    billing: [],
    client_admin: CLIENT_ROLES,
    client_user: [],
};
export function permissionsFor(roles) {
    const out = new Set();
    for (const role of roles)
        for (const p of ROLE_PERMISSIONS[role])
            out.add(p);
    return out;
}
export function assignableRoles(actorRoles) {
    const out = new Set();
    for (const role of actorRoles)
        for (const r of ASSIGNABLE_BY[role])
            out.add(r);
    return out;
}
/** True when the actor may grant every role in `target` to a user of `kind`. */
export function canAssignRoles(actorRoles, kind, target) {
    const allowed = assignableRoles(actorRoles);
    const forKind = ROLES_BY_KIND[kind];
    return target.every((r) => allowed.has(r) && forKind.includes(r));
}
export function isRole(value) {
    return ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map